<template>
  <div style="margin: 30px 0;">
    <div class="row">
        <div id="gdpr-unsubscribe-main-text" class="col-md-12">
            <h2>Hvala na <span class="gdpr-color-text">povratnoj informaciji!</span></h2>
            <p v-html="$store.state.texts.unsubscribe.unsubscribeSubTitle1"></p>
        </div>
    </div>
    <div class="row social-text">
        <div class="col-md-12">
            <h3>Jeste li se odjavili <span class="gdpr-color-text">slučajno?</span></h3>
            <p v-html="$store.state.texts.unsubscribe.unsubscribeSubTitle2"></p>
        </div>
    </div>
    <div id="gdpr-submit-button">
        <button class="btn btn-lg btn-primary" @click="urediPodatke()" v-html="$store.state.texts.unsubscribe.unsubscribeBtn"></button>
    </div>
    <div class="row social-text">
        <div class="col-md-12">
            <h3 v-html="$store.state.texts.unsubscribe.socialTitle"></h3>
            <p v-html="$store.state.texts.social.subtitle"></p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3 col-sm-6">
            <a href="https://www.renault.hr/" target="_blank"><div class="social-container">
                <i class="fas fa-home fa-4x fa-inverse"></i>
                <p v-html="$store.state.texts.social.icon1"></p>
            </div></a>
        </div>
        <div class="col-md-3 col-sm-6">
            <a href="https://www.facebook.com/RenaultHrvatska" target="_blank"><div class="social-container">
                <i class="fab fa-facebook-f fa-4x fa-inverse"></i>
                <p>Facebook</p>
            </div></a>
        </div>
        <div class="col-md-3 col-sm-6">
            <a href="https://www.instagram.com/renault_hr/" target="_blank"><div class="social-container">
                <i class="fab fa-instagram fa-4x fa-inverse"></i>
                <p>Instagram</p>
            </div></a>
        </div>
        <div class="col-md-3 col-sm-6">
            <a href="https://www.youtube.com/channel/UCx7jWVytrg6wzEySaw5bskA" target="_blank"><div class="social-container">
                <i class="fab fa-youtube fa-4x fa-inverse"></i>
                <p>Youtube</p>
            </div></a>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    beforeCreate() {
        if(this.$store.state.ime === ''  && this.$store.state.priimek === '') {
            this.$router.push({name: 'Form'})
        }
    },
    methods: {
        urediPodatke() {
            this.$router.push({name: 'Form'})
        }
    }
}
</script>
<style lang="scss" scoped>
    .gdpr-color-text {
        color: #FFCE00;
    }
     /*SOCIAL*/
    .social-text {
        margin-top: 50px;
    }
    .social-container {
        text-align: center;
        background-color: #FFCE00;
        i {
            margin-top: 30px;
        }
        p {
            padding: 20px;
            color: white;
            position: relative;
        }
        p:after {
            content: ">";
            position: absolute;
            right: 15%;
            top: 36%;
        }
    }

    // BUTTON
    /* SUBMIT BUTTON */
    #gdpr-submit-button{
        text-align: center;
        margin: 10% 0 3% 0;
        button {
            background-color: #FFCE00;
            border-color: #FFCE00;
            padding: 10px 85px;
            border-radius: 0;
            position: relative;
            font-family: Renault Regular,Helvetica,Arial,sans-serif;
            text-transform: uppercase;
        }
        button:hover {
            background-color: #fd3;
            border-color: #fd3;
        }
        button:after{
            font-size: 20px;
            position: absolute;
            top: 35%;
            margin-top: -.3333333333em;
            right: 30px;
            content: ">";
        }
    }
    .btn-primary {
        color: #000;
    }

    /* RESPONSIVE STYLING */
    @media only screen and (max-width : 992px) {
        .social-container {
            p:after {
                right: 30%;
            }
        }
    }
    @media only screen and (max-width: 768px) {
        .social-container {
            p:after {
                right: 35%;
            }
        }
    }
    @media only screen and (max-width : 480px) {
        .social-container {
            p:after {
                right: 30%;
            }
        }
    }
    @media only screen and (max-width : 320px) {
        .social-container {
            p:after {
                right: 25%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Unsubscribe.vue